import { css } from "styled-components";

import MapControlButtonStyle from "./MapControlButtonStyle";

const MapControlCameraStyle = (icon = null) => css`
  ${MapControlButtonStyle(icon)};
`;

export default MapControlCameraStyle;
